import * as tslib_1 from "tslib";
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { confirm } from 'owa-confirm-dialog';
import clearSearchHistoryUserConfig from 'owa-privacy-option/lib/utils/clearSearchHistory';
import exportSearchHistoryUserConfig from 'owa-privacy-option/lib/utils/exportSearchHistory';
var styles = require('./PrivacyFull.scss');
var PrivacyFull = /** @class */ (function (_super) {
    tslib_1.__extends(PrivacyFull, _super);
    function PrivacyFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivacyFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("p", null, strings.option_privacy_searchHistory_description),
            React.createElement("div", { className: styles.buttonContainer },
                React.createElement(DefaultButton, { onClick: confirmAndClearSearchHistory, className: styles.button }, strings.option_privacy_searchHistory_delete),
                React.createElement(DefaultButton, { className: styles.button, onClick: exportSearchHistoryUserConfig }, strings.option_privacy_searchHistory_export))));
    };
    return PrivacyFull;
}(React.Component));
export default PrivacyFull;
function confirmAndClearSearchHistory() {
    var confirmationDialogPromise = confirm(strings.option_privacy_searchHistory_delete_confirmation_title, strings.option_privacy_searchHistory_delete_confirmation_description, false /*resolveImmediately*/, {
        okText: strings.option_privacy_searchHistory_delete_confirmation_continueButton,
        cancelText: strings.option_privacy_searchHistory_delete_confirmation_cancelButton,
    });
    confirmationDialogPromise.then(clearSearchHistoryUserConfig);
}
//# sourceMappingURL=PrivacyFull.js.map